import ListingDatesValidatorService from '@spotahome/ui-library/src/tenant/components/utils/listing-dates-validator-service';

import AdUnavailabilityService from '@spotahome/marketplace-common/src/LEGACY/javascripts/cornucopia/ads/ad-unavailability-service';

import { BOOKING_STATUSES } from '../constants';

export const getBookingStatus = (moveIn, moveOut, listing) => {
  const {
    availableFromDateIso8601,
    maxStay,
    minStay,
    moveInDatesRanges,
    unavailabilities
  } = listing;

  let status;
  const isAvailable =
    AdUnavailabilityService.isAvailable(moveIn, moveOut, unavailabilities) &&
    ListingDatesValidatorService.isMaxStayValid(moveIn, moveOut, maxStay) &&
    ListingDatesValidatorService.isMinStayValid(moveIn, moveOut, minStay) &&
    ListingDatesValidatorService.isMoveInDateValid(moveIn, moveInDatesRanges);

  if (availableFromDateIso8601 === null) {
    status = BOOKING_STATUSES.UNDEFINED_VALIDATION;
  } else if (!moveIn || !moveOut) {
    status = BOOKING_STATUSES.EMPTY_VALIDATION;
  } else if (isAvailable) {
    status = BOOKING_STATUSES.IS_AVAILABLE_VALIDATION;
  } else {
    status = BOOKING_STATUSES.NOT_AVAILABLE_VALIDATION;
  }

  return status;
};
